<template>
<div>


		<section id="footer">
				<div class="container">
					<div class="row">
									</div>
				</div>
			</section>
			
			<section id="post-footer">
				<div class="container">
					<div class="row">
						<div class="col-xs-12">
							<h6><p><img src="/static/images/iba-logo-white.png" alt="Infinitt Business Analytics" style="width: 150px; margin-bottom: 10px;"></p>
		© 2022 IBA - Infinitt Business Analytics. All Rights Reserved.
		<!--<h3><a href="tel:801-701-6518">801-701-6518</a></h3>--> </h6>
													<div id="social-footer">
								</div>
							
						</div>
					</div>
				</div>
			</section>
        </div>
</template>

<script>
    import {EventBus} from '../event-bus.js'

    export default {
        name: 'my-footer',
        data () {
            return {
               
            }
        },
        mounted(){

            
        },
        methods:{
            showNoty: function(){
                EventBus.$emit('noty', {type:'success',msg:'hurray!'});
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/js/components/MyFooter.vue